module.exports = __webpack_public_path__ + "media/assets/images/report_en-c68acd8f9979525e216e2c8a1d291702.png";